var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.updateWindowHeight),expression:"updateWindowHeight"}]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }